import { VISA_TYPE_MAP } from '@/lib/queries/business/constants'

export const VISA_TYPE_SELECT_ITEMS: { label: string; value: string }[] = [
  {
    label: 'NVC - Immigrant Visa',
    value: VISA_TYPE_MAP.immigrant,
  },
  {
    label: 'NVC - Nonimmigrant Visa',
    value: VISA_TYPE_MAP['non-immigrant'],
  },
] as const
